import React from 'react';
import { EmptyLarge } from './components/EmptyLarge.js';
import { EmptyMedium } from './components/EmptyMedium.js';
import { EmptySmall } from './components/EmptySmall.js';
import { FailLarge } from './components/FailLarge.js';
import { FailMedium } from './components/FailMedium.js';
import { FailSmall } from './components/FailSmall.js';
import { ProcessLarge } from './components/ProcessLarge.js';
import { ProcessMedium } from './components/ProcessMedium.js';
import { ProcessSmall } from './components/ProcessSmall.js';
import { SuccessLarge } from './components/SuccessLarge.js';
import { SuccessMedium } from './components/SuccessMedium.js';
import { SuccessSmall } from './components/SuccessSmall.js';

const Whale = ({ size = 'medium', type = 'success' }) => {
    const node = {
        empty: {
            large: React.createElement(EmptyLarge, null),
            medium: React.createElement(EmptyMedium, null),
            small: React.createElement(EmptySmall, null),
        }[size],
        fail: {
            large: React.createElement(FailLarge, null),
            medium: React.createElement(FailMedium, null),
            small: React.createElement(FailSmall, null),
        }[size],
        process: {
            large: React.createElement(ProcessLarge, null),
            medium: React.createElement(ProcessMedium, null),
            small: React.createElement(ProcessSmall, null),
        }[size],
        success: {
            large: React.createElement(SuccessLarge, null),
            medium: React.createElement(SuccessMedium, null),
            small: React.createElement(SuccessSmall, null),
        }[size],
    }[type];
    return node;
};

export { Whale };
//# sourceMappingURL=Whale.js.map
